export const ScreenType = {
  CHECK_BOX: "CB",
  CONSENT: "CT",
  CONTACT_NUMBER: "CN",
  DIVISION: "DIV",
  DRILLED_DOWN: "DD",
  EMAIL_ADDRESS: "EA",
  EMOJI_NPS: "EM",
  ICON: "IC",
  IMAGE: "IM",
  MEDIA: "MD",
  LABELLED_IMAGE: "LIM",
  LIST: "LI",
  NPS: "NP",
  OPEN_ENDED: "OE",
  PRODUCTS_LIST: "PR",
  STAR: "ST",
  TEXT_AREA: "TXA",
  TEXT_INPUT: "TXI",
  TILE: "TI",
  DESCRIPTION: "DSC",
  ASSIGNEE: "ASN",
  MCQS: "MQ",
  FEEDBACK_REVIEW: "FBR",
};

export const OpenEndedScreens = {
  [ScreenType.TEXT_AREA]: true,
  [ScreenType.OPEN_ENDED]: true,
};

export const UserInfoQuestions = {
  [ScreenType.LIST]: true,
  [ScreenType.LABELLED_IMAGE]: true,
  [ScreenType.EMAIL_ADDRESS]: true,
  [ScreenType.CONTACT_NUMBER]: true,
};
